import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { msg } from "@omegagrid/localize";

@customElement('rp-job-timer')
export class JobTimer extends LitElement {
	
	@property({ type: String })
	start?: string;
	
	@property({ type: Number })
	last?: number;
	
	@property({ type: String })
	step?: string;
	
	_interval?: number;
	_duration?: number;
	_canDispatchEvent: boolean = false;

	connectedCallback() {
		this.render();
		this._interval = window.setInterval(() => this.render(), 1000);
	}

	disconnectedCallback() {
		if (this._interval) {
			clearInterval(this._interval);
			this._interval = undefined;
		}
	}

	private pad(n: number) { return n < 10 ? `0${n}` : `${n}`; }

	formatDurationFromStart(): string {
		const startDate = this.start ? new Date(this.start) : undefined;
		if (!startDate || Number.isNaN(startDate.getTime())) return '';
		this._duration = Date.now() - startDate.getTime();
		if (this._duration < 0) this._duration = 0;
		const totalHours = Math.floor(this._duration / 3600000);
		const minutes = Math.floor(this._duration / 60000) % 60;
		const seconds = Math.floor(this._duration / 1000) % 60;
		if (totalHours > 0) return `${this.pad(totalHours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
		return `${this.pad(minutes)}:${this.pad(seconds)}`;
	}

	render() {
		let text = this.formatDurationFromStart();
		if (this.last > 0) {
			const percentage = Math.round((this._duration / 1000) / this.last * 100);
			if (percentage < 100) this._canDispatchEvent = true;
			else if (this._canDispatchEvent) this.dispatchEvent(new CustomEvent('complete', { bubbles: true, composed: true }));
			//text += ` (${msg('est.')} ${percentage}%`;
			text += ` (${msg('est.')} ${percentage}% <progress style="width: 50px;" value="${percentage}" max="100"> ${percentage}%</progress>`;
			if (this.step) text += ` ${this.step}`;
			text += `)`;
		}
		this.innerHTML = `<span>${text}</span>`;
	}
}
